// extracted by mini-css-extract-plugin
module.exports = {"error-tooltip":"ErrorTooltip_error-tooltip__3rzce","text":"ErrorTooltip_text__M2unk"};